"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    fill: "none",
    stroke: "#fff",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.467 24c6.332 0 11.466-5.134 11.466-11.467S18.8 1.067 12.467 1.067C6.134 1.067 1 6.2 1 12.533 1 18.866 6.134 24 12.467 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.489 17.067a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.293 9.698s-1.596-3.481-5.49-3.1M16.64 9.81s1.388-3.589 5.286-3.48M2.911 18.629s1.476-4.012 5.46-3.817M21.8 18.84s-1.237-3.832-5.511-3.907m5.821 3.907a1.65 1.65 0 0 1-.302 2.619l-.944.554a2 2 0 0 0-.592.532l-.505.68a1.863 1.863 0 0 1-2.904.109M22.11 6.25a1.65 1.65 0 0 0-.302-2.618l-.944-.555a2.001 2.001 0 0 1-.592-.532l-.505-.68a1.863 1.863 0 0 0-2.904-.109M2.587 18.84a1.65 1.65 0 0 0 .301 2.619l.944.554a2 2 0 0 1 .592.532l.505.68a1.863 1.863 0 0 0 2.904.109M2.587 6.25a1.65 1.65 0 0 1 .301-2.618l.944-.555a2 2 0 0 0 .592-.532l.505-.68a1.863 1.863 0 0 1 2.904-.109"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgHelp);
var _default = Memo;
exports["default"] = _default;